import { useState, useEffect } from "react";
import { database } from "../firebase/config";
import { ref, onValue } from "firebase/database";

export const useCollection = (path) => {
    const [data, setData] = useState(null)
    const [keys, setKeys] = useState(null)
 
        useEffect(() => {
            const dbRef = ref(database, path);  
            const unsub = onValue(dbRef, (snapshot) => {
                let results = []
                let keys = []
                snapshot.forEach((childSnapshot) => {
                    const childKey = childSnapshot.key
                    const childData = childSnapshot.val()
                    keys.push({childKey})
                    results.push({...childData})
                })
                setData(results)
                setKeys(keys)
            }, {
                 onlyOnce: false //path !== "/Users" ? true : false
            });
          return () => unsub() 
     
         }, [path])
    return { data, keys }
}
